import type { Root, InlineCode } from "mdast";
import { visit } from "unist-util-visit";

import { ANNOTATION_TAG_PATTERN } from "../annotation-tags";

/**
 * An annotation tag the model wrapped in backticks still renders as a chip: the inline code becomes raw
 * HTML so the rest of the pipeline parses the tag. Any other code span stays inline code, which renders as
 * escaped text. Parsing it as HTML would turn a mention of `<iframe>` into a real element, and a raw-text
 * element like that swallows the rest of the answer.
 */
export function codeTickTransform() {
  function transformer(tree: Root) {
    visit(tree, "inlineCode", (node, index, parent) => {
      if (!parent || index == null) return;

      const { value } = node as InlineCode;
      if (!ANNOTATION_TAG_PATTERN.test(value)) return;

      parent.children[index] = {
        type: "html",
        value: `<code>${value}</code>`,
      };
    });
  }

  return transformer;
}
